<template>
  <tr>
 
    <td>

   <button
        v-if="parametre.cron"
        class="btn btn-circle btn-success"
        title="Cliquer pour désactiver"
      >
        <i class="fas fa-check"></i>
      </button>
      <button
        v-if="!parametre.cron"
        class="btn btn-circle btn-danger"
        title="Cliquer pour activer"
      >
        <i class="fas fa-check"></i>
      </button> 
    
    </td>
    <td>


    
      {{
        parametre.footer_message
      }}
    </td>
    <td>
      <button
        class="btn btn-primary btn-circle mr-2"
        v-if="userPermissions.some((e) => [P_PARAM_MASTER].includes(e))"
        title="Modifier"
        @click="edit(parametre.id)"
      >
        <i class="fas fa-edit"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";

import {
  FETCH_PARAMETRE,
} from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { P_PARAM_MASTER } from "@/helpers/permissions";

export default {
  name: "VisatypeItem",
  data() {
    return {
      submitted: false,
      id: "",
      P_PARAM_MASTER
    };
  },
  props: {
    parametre: { type: Object, required: true },
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  methods: {
    edit(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_PARAMETRE, id)
        .then(() => {
          this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "parametre-edit" });
        })
        .catch(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
  },
};
</script>

<style lang="scss">
</style>